
/*eslint-disabled*/
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ClickOutside } from 'vuetify/lib/directives';
import { brandLogo, brandMark, brandName, isWhitelabel } from '@/utils/brand';
import { ISideBar, IUser } from '@/types/types';

@Component({ directives: { ClickOutside } })
export default class SideBar extends Vue {
  /* brand mark and name, overridable per whitelabel from build-time env */
  get brandLogo(): string {
    return brandLogo();
  }

  get brandName(): string {
    return brandName();
  }

  get brandMark(): string {
    return brandMark();
  }

  /* partner logos are opaque images, so they cannot be drawn as the white
     silhouette the Kairos mark uses on the navy rail */
  get isWhitelabel(): boolean {
    return isWhitelabel();
  }
  @Prop({ type: Boolean, default: true }) drawer!: boolean;
  @Prop({ type: Array, default: () => [], required: true })
  sideBarItems!: Array<ISideBar>;
  @Prop({ type: Object, default: null })
  user!: IUser;

  closer: boolean = this.drawer;
  menu = false;

  /* mini rail (590–1300px) flown out to full width, over the page */
  expanded = false;

  collapse(): void {
    this.expanded = false;
  }

  @Watch('$route')
  onRouteChange(): void {
    this.collapse();
  }
}
